import { queryFor } from "@visioni/a3s-client-api/app";
import { getAlarmConfigurationEndpoint } from "../client-messages/alarms";

/**
 * React Query options factory for the alarm configuration of a camera.
 * Usage: `alarmConfigurationQuery(apiConfig, pathParams)` inside `useQuery(...)`.
 */
export const alarmConfigurationQuery = queryFor(getAlarmConfigurationEndpoint);
